import { StyleSheet } from "react-native";
import { appColors } from '../../appTheme';

export const paymentListStyle = StyleSheet.create({
    outerContainer: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
        marginHorizontal: 10,
        justifyContent: "space-between",
    },
    searchBarView: {
        marginRight: 5
    },
    createPaymentView: {
        flexDirection: "row",
        alignItems: "center",
    },
    filterIconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 10,
        borderColor: appColors.lightGrey,
        marginLeft: 5
    },
    filterTextStyle: {
        paddingLeft: 5
    },
    listOuterView: {
        backgroundColor: appColors?.light,
        borderRadius: 5
    },
    listFirstView: {
        flexDirection: 'row',
        alignItems: "center",
        justifyContent: "space-between"
    },
    listSecondView: {
        flexDirection: "row",
        alignItems: "center",
    },
    optionView: {
        borderWidth: 1,
        borderRadius: 11,
        width: 40,
        height: 40,
        margin: 3,
        padding: 3,
        borderColor: appColors.light,
        backgroundColor: appColors.lightBackgroundColor,
        justifyContent: "center",
        alignItems: "center"
    }

})